<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'usersCrud'"
          :crudName="$t('uf.title')"
          :newText="$t('uf.form.newText')"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="$hasAbility('cadastro.gerenciar')"
          :enableEdit="$hasAbility('cadastro.gerenciar')"
          :enableDelete="$hasAbility('cadastro.gerenciar')"
          :enableView="false"
          :enableReset="false"
          :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "ufsTable",
      showMessageImport: false,
      usersCrud: {},
      pages: [],
      url: "",
      columns: ["id", "code", "name", "status", "actions"],
      tableData: ["id", "code", "name", "cbo_code_sus", "status"],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id", "code", "name", "status"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          code: this.$t("uf.table.code"),
          name: this.$t("uf.table.name"),
          status: this.$t("common.status"),
          actions: this.$t("common.actions"),
        },
        sortable: ["id", "code", "name", "status"],
        sortIcon: {
          base: "fas",
          up: "fa-chevron-up",
          down: "fa-chevron-down",
          is: "fa-sort",
        },
        texts: {
          filterBy: this.$t("uf.table.filterBy"),
          defaultOption: this.$t("common.select"),
        },
        listColumns: {
          status: [
            {
              id: 1,
              text: this.$t("common.active"),
            },
            {
              id: 0,
              text: this.$t("common.inactive"),
            },
          ],
        },
        templates: {},
        requestFunction: function (data) {
          let requestData = {};

          console.log(this.$parent.$parent);

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = [];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "ufs",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      let fileImport = document.getElementById("fileImport");

      fd.append("fileImport", fileImport.files[0] ? fileImport.files[0] : "");

      return fd;
    },
    query: function (query) {
      let columns = {
        id: "id",
        code: "code",
        name: "name",
        status: "status",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>